import { z } from "zod/v4";

export const JS_IDENTIFIER_REGEX = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/;

export const REQUEST_PAGE_RESERVED_NAMES = new Set([
	"base",
	"pageStorage",
	"pageStorageCommit",
	"window",
	"React",
	"std",
	"httpRequest",
	"currentUser",
	"render",
	"jsx",
	"memo",
	"forwardRef",
	"component",
	"useCellValue",
	"dateFns",
	"designSystem",
	"CellServicesContextProvider",
	"useCellServices",
	"documentInteractionMode",
	"DesignSystemThemeProvider",
	"ReactErrorBoundary",
]);

export type RequestPageNameValidation = { error?: string };

export function validateRequestPageName(
	name: string,
	currentPageId: string,
	pagesMetadata: PageMetadata[]
): RequestPageNameValidation {
	if (!name) {
		return {};
	}
	if (!JS_IDENTIFIER_REGEX.test(name)) {
		return { error: "Must be a valid JavaScript identifier" };
	}
	if (REQUEST_PAGE_RESERVED_NAMES.has(name)) {
		return { error: "This name conflicts with a builtin and won't be callable from code" };
	}
	const isDuplicate = pagesMetadata.some(
		(p) => p.type === "request" && p.id !== currentPageId && p.title === name
	);
	if (isDuplicate) {
		return { error: "A request with this name already exists" };
	}
	return {};
}

export const pageMetadata = z.object({
	id: z.string(),
	slug: z.string(),
	title: z.string(),
	path: z.string().optional(),
	type: z.union([z.literal("markdown"), z.literal("canvas"), z.literal("request")]).optional(),
	archived: z.boolean().default(false),
	authorID: z.string().optional(),
	parentPageID: z.string().nullable().optional(),
	publishedOn: z.coerce.date().optional(),
});

export type PageMetadata = z.infer<typeof pageMetadata>;
